import { render, staticRenderFns } from "./StepProgramAssets.vue?vue&type=template&id=4e8797ac&scoped=true"
import script from "./StepProgramAssets.vue?vue&type=script&lang=js"
export * from "./StepProgramAssets.vue?vue&type=script&lang=js"
import style0 from "./StepProgramAssets.vue?vue&type=style&index=0&id=4e8797ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8797ac",
  null
  
)

export default component.exports